import { DictionaryEntry } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { PersonalVisitStatus } from './widgets/personal-visit-list/personal-visit-list.model';

export class Visit {
  id: number = -1;
  visitorType: number;
  visitorId: number;
  name: string;
  firstname: string;
  company: string;
  numberPlate: string;
  start: string;
  end: string;
  rowStyle: string;
  hintStyle: string;
  reason: string;
  notes: string;
  inRegularIntervals: boolean;
  registrationCode: string;
  searchText: string;
  visitedPersonString: string;
  visitedPerson = new InhouseContact();
  members = new Array<VisitorMember>();
  pastVisits = new Array<VisitXYZ>();
  equipment = new Array<SupplementaryEquipment>();
  useGlobalConnect: boolean;
  plannedArrival: string;
  reservation: boolean;
  sendVisitorMail: boolean;
  visitorMail: string;
  withCar: boolean;
  needsAreaAccessByCar: boolean;
  grandAreaAccessByCar: boolean;
  grandAreaAccessOnFoot: boolean;

  registerEntrance: boolean;

  inviteAdditionalVisitorsAllowed: boolean;

  endByRole: string;
  defineVisitEnd: boolean;
  definedVisitEnd: string;
  visitEnd: string;

  visitLogs = new Array<VisitLog>();
  tasks = new Array<VisitTask>();

  allowOverrideRoleSettings: boolean;
  invitationRequiresConfirmation: boolean;
  invitationConfirmationOnAccessOnly: boolean;
  assignPrivilegesOnInvitation: boolean;
  personalId: string;
  confirmed: boolean;
  personalVisitStatus: PersonalVisitStatus;

  constructor(visit?: any) {
    if (visit != null) {
      this.id = visit.id;
      this.confirmed = visit.confirmed;
      this.personalVisitStatus = visit.personalVisitStatus;
      this.visitorType = visit.visitorType;
      this.visitorId = visit.visitorId;
      this.name = visit.name;
      this.firstname = visit.firstname;
      this.company = visit.company;
      this.numberPlate = visit.numberPlate;
      this.start = visit.start;
      this.end = visit.end;
      this.rowStyle = visit.rowStyle;
      this.hintStyle = visit.hintStyle;
      this.reason = visit.reason;
      this.notes = visit.notes;
      this.inRegularIntervals = visit.inRegularIntervals;
      this.registrationCode = visit.registrationCode;
      this.searchText = visit.searchText;
      this.visitedPersonString = visit.visitedPersonString;
      if (visit.visitedPerson != null) {
        this.visitedPerson = new InhouseContact(visit.visitedPerson);
      }
      if (visit.members != null) {
        for (const member of visit.members) {
          this.members.push(new VisitorMember(member))
        }
      }
      this.useGlobalConnect = visit.useGlobalConnect;
      this.plannedArrival = visit.plannedArrival;
      this.reservation = visit.reservation;
      this.sendVisitorMail = visit.sendVisitorMail;
      this.visitorMail = visit.visitorMail;
      this.withCar = visit.withCar;
      this.needsAreaAccessByCar = visit.needsAreaAccessByCar;
      this.grandAreaAccessByCar = visit.grandAreaAccessByCar;
      this.grandAreaAccessOnFoot = visit.grandAreaAccessOnFoot;
      this.registerEntrance = visit.registerEntrance;
      this.inviteAdditionalVisitorsAllowed = visit.inviteAdditionalVisitorsAllowed;

      this.endByRole = visit.endByRole;
      this.defineVisitEnd = visit.defineVisitEnd;
      this.definedVisitEnd = visit.definedVisitEnd;
      this.visitEnd = visit.visitEnd;

      if (visit.visitLogs != null) {
        for (const visitLog of visit.visitLogs) {
          this.visitLogs.push(new VisitLog(visitLog))
        }
      }

      if (visit.tasks != null) {
        for (const task of visit.tasks) {
          this.tasks.push(new VisitTask(task))
        }
      }

      this.allowOverrideRoleSettings = visit.allowOverrideRoleSettings;
      this.invitationRequiresConfirmation = visit.invitationRequiresConfirmation;
      this.invitationConfirmationOnAccessOnly = visit.invitationConfirmationOnAccessOnly;
      this.assignPrivilegesOnInvitation = visit.assignPrivilegesOnInvitation;
      this.personalId = visit.personalId;
    }
  }
}


export class VisitLog {
  timestamp: string;
  activityType: string;
  note: string;
  displayString: string;

  constructor(visitLog?: any) {
    if (visitLog != null) {
      this.timestamp = visitLog.timestamp;
      this.activityType = visitLog.activityType;
      this.note = visitLog.note;
    }
  }
}

export class VisitTask {

  id: number;
  taskId: number;
  optional: boolean;
  done: boolean;
  doneBefore: boolean;

  constructor(task?: any) {
    if (task != null) {
      this.id = task.id;
      this.taskId = task.taskId;
      this.optional = task.optional;
      this.done = task.done;
      this.doneBefore = task.doneBefore;
    }
  }
}

export class PersonalVisitEntrance {

}


export class InhouseContact {
  id: number;
  name: string;
  department: string;
  phone: string;
  mail: string;

  constructor(contact?: any) {
    if (contact != null) {
      this.id = contact.id;
      this.name = contact.name;
      this.department = contact.department;
      this.phone = contact.phone;
      this.mail = contact.mail;
    }
  }
}

export enum ParamterType {
  NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}

export class SearchVisitor {
  name: string;
  firstname: string;
  company: string;
}



export class SupplementaryEquipmentResponse extends ServiceResponse {
  equipments: SupplementaryEquipment[];
}


export class SupplementaryEquipment {
  key: string;
  dictionaryKey: string;
  selected: boolean;
  handouted = false;
  parameter1DictionaryKey: string;
  parameter1Type: ParamterType;
  parameter1Value: string;
}


export class VisitXYZ {
  id: number;
  entrance: string;
  leave: string;
  visitedPerson: InhouseContact;
}

export class Visitor {
  id: number;
  name: string;
  firstname: string;
  company: string;
  numberPlate: string;
  members: Array<VisitorMember>;
}

export class VisitorMember {
  id: number = null;
  name: string = null;
  firstname: string = null;
  /** Helper in client to identicate, that there esists another member with same name/firstname. */
  possibleDuplicate = false;

  constructor(member?: any) {
    if (member != null) {
      this.id = member.id;
      this.name = member.name;
      this.firstname = member.firstname;
      this.possibleDuplicate = member.possibleDuplicate;
    }
  }
}

export class VisitorRoleReference {

  id: number;
  dictionaryKey: string;
  validDaysCount: number;
  allowYardEntranceByCar: boolean;
  allowYardEntranceOnFoot: boolean;

  allowOverrideRoleSettings: boolean;
  invitationRequiresConfirmation: boolean;
  invitationConfirmationOnAccessOnly: boolean;
  assignPrivilegesOnInvitation: boolean;

  tasks = new Array<VisitorRoleTask>();

  constructor(type?: any) {
    if (type != null) {
      this.id = type.id;
      this.dictionaryKey = type.dictionaryKey;
      this.validDaysCount = type.validDaysCount;
      this.allowYardEntranceByCar = type.allowYardEntranceByCar;
      this.allowYardEntranceOnFoot = type.allowYardEntranceOnFoot;
      this.allowOverrideRoleSettings = type.allowOverrideRoleSettings;
      this.invitationRequiresConfirmation = type.invitationRequiresConfirmation;
      this.invitationConfirmationOnAccessOnly = type.invitationConfirmationOnAccessOnly;
      this.assignPrivilegesOnInvitation = type.assignPrivilegesOnInvitation;
      if (type.tasks != null) {
        for (const task of type.tasks) {
          this.tasks.push(new VisitorRoleTask(task))
        }
      }
    }
  }
}

export class VisitorType {

  id: number;
  name = new DictionaryEntry();
  externalKey: string;
  icon: string;

  constructor(type?: any) {
    if (type != null) {
      this.id = type.id;
      this.name = new DictionaryEntry(type.name);
      this.externalKey = type.externalKey;
      this.icon = type.icon;
    }
  }
}

export class VisitorRoleTask {

  id: number;
  name = new DictionaryEntry();
  validity: number;
  optional: boolean;
  deleted: boolean;

  constructor(task?: any) {
    if (task != null) {
      this.id = task.id;
      this.name = new DictionaryEntry(task.name);
      this.validity = task.validity;
      this.optional = task.optional;
    }
  }
}

export class TerminalVisitorRegistrationResult extends ServiceResponse {

  numberPlate: string;
  trailerNumberPlate: string;
  registrationId: number;
  driver: string;
  coDriver: string;
  carrier: string;
  supplier: string;
  orderReference: string;
  registrationCode: string;
  gatekeeperMandatory: boolean;

  constructor(details?: Partial<TerminalVisitorRegistrationResult>) {
    super(details);
    if (details != null) {
      this.carrier = details.carrier;
      this.coDriver = details.coDriver;
      this.driver = details.driver;
      this.supplier = details.supplier;
      this.numberPlate = details.numberPlate;
      this.trailerNumberPlate = details.trailerNumberPlate;
      this.orderReference = details.orderReference;
      this.registrationId = details.registrationId;
      this.registrationCode = details.registrationCode;
      this.gatekeeperMandatory = details.gatekeeperMandatory;
    }
  }
}
